import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Area } from '@app/models/area';
import { AreaService } from '@app/services/area.service';

@Component({
  selector: 'app-area-form',
  templateUrl: './area-form.component.html'
})
export class AreaFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  titulo: string;
  lstErros: string[];
  area: Area = new Area();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private areaService: AreaService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Área' : 'Nova Área';

      if (!id) {
        return;
      }

      this.areaService.obterPorId(id).toPromise().then(
        data => this.area = data,
        () => this.router.navigate(['./configuracoes/cidade']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.areaService.gravar(this.area).toPromise().then(
        () => this.router.navigate(['./configuracoes/area']),
        (data: any) => {
            if (data.error) {
                this.lstErros = data.error.errors;
            }
            this.aguardandoSolicitacao = false;
      });
  }
}
